import { useHistory } from 'react-router-dom'
import { Button } from '@mui/material'
import { Header } from '../../components/Header';
import { OutputTable } from './JsonOutputTable';
import { InputAudioTable } from './InputAudioTable';
import AnalyticsFileTable from '../heatMapInfo/AnalyticsFileTable';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import { Box } from '@mui/material';

const OutputFiles = () => {
    const queryParameters = new URLSearchParams(window.location.search)
    const id = queryParameters.get("id")
    const snsi_id = queryParameters.get("snsi_id")

    return (
        <Box sx={{ display: 'inline-flex', width: '100%', justifyContent: 'space-between'} }>
            <Box sx={{ width: '35%' }}>
                <AnalyticsFileTable network_run_id={id} />
            </Box>
            <Box sx={{ width: '65%' }}>
                <Header
                    pageTitle="JSON Output"
                />
                <OutputTable filetype={"json"} network_run_id={id} />
                <Header
                    pageTitle="Wav Output"
                />
                <OutputTable filetype={"wav"} network_run_id={id} />
                <Header
                    pageTitle="Input Files"
                />
                <InputAudioTable snsi_id={snsi_id} />
            </Box>
            
        </Box>
    )
}

export default withRouter(OutputFiles);